// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1__f92f3aac94a4ca86ae62","cls2":"Comments-cls2__f72bd390945e3d5df8bd Comments-cls1__f92f3aac94a4ca86ae62","short":"Comments-short___4614e687738fa1c792d"};